import React from 'react';

import RoundCheckbox from '../UI/Checkbox/RoundCheckbox/RoundCheckbox'
import Accordion from '../UI/Accordion/Accordion';
import classes from './RadioSelection.css';

const MenuContent = ({ content }) => (
  <div className={classes.MenuContent}>
    <p dangerouslySetInnerHTML={{ __html: content }}></p>
  </div>
)

const RadioSelection = props => {
  const choices = props.options.map(val => {
    const isMenuSelected = val.id === props.selection;
    const Menu = <MenuContent content={val.description} />
    return (
      <div className={classes.OptionContainer} key={val.id}>
        <div className={classes.MenuHeaderContainer} onClick={() => props.optionHandler(val.id)}>
          <div className={classes.CheckBoxContainer}>
            <RoundCheckbox
              isChecked={isMenuSelected}
              id={val.id}
              name={val.name}
              clicked={() => { }}
            />
          </div>
          <div className={[classes.OptionTitlePriceContainer, isMenuSelected && classes.OptionTitleSelected].join(' ')}>
            <p className={classes.OptionTitle}>{val.name}</p>
            {val.promotionPrice !== 0 && <p className={classes.OptionPrice}>{
              props.translations.label_price_menu && props.translations.label_price_menu.replace('{0}', val.promotionPrice)}
            </p>}
          </div>
        </div>
        <Accordion content={Menu} isOpen={isMenuSelected} />
      </div>
    )
  });

  return (
    <div className={classes.Container}>
      {choices}
    </div>
  )
}

export default RadioSelection;


// WEBPACK FOOTER //
// ./src/components/RadioSelection/RadioSelection.js